<template></template>

<script>
    export default {
        name: 'TitleFlipper',

        props: {
            titles: {type: Array, required: true},
            speed: {type: Number, default: 1000},
        },

        data() {
            return {
                originalTitle: document.title,
                currentTitle: 0,
                interval: null,
            };
        },

        mounted() {
            window.addEventListener('blur', this.start, { passive: true });
            window.addEventListener('focus', this.stop, { passive: true });
        },

        beforeDestroy() {
            window.removeEventListener('blur', this.start);
            window.removeEventListener('focus', this.stop);
            this.stop();
        },

        computed: {
            allTitles() {
                return [this.originalTitle, ...this.titles];
            }
        },

        watch: {
            currentTitle(newValue) {
                document.title = this.allTitles[newValue];
            },
            interval(newValue, oldValue) {
                if (oldValue && newValue !== oldValue) {
                    clearInterval(oldValue);
                }
            }
        },

        methods: {
            advanceTitle() {
                this.currentTitle = (this.currentTitle + 1) % this.allTitles.length;
            },

            start() {
                this.stop();
                this.interval = setInterval(() => this.advanceTitle(), this.speed);
            },

            stop() {
                this.interval = null;
                this.currentTitle = 0;
            },
        }
    }
</script>
